<h1>Contactgegevens</h1>
  
Alpacamundo
<br>
Anniek van Dijk & Auke Wesselink
<p>
Scheiding 8<br>
9231 AN Surhuisterveen<br>
NEDERLAND<br>
E-mail: <a HREF="mailto:info@alpacamundo.eu?SUBJECT=Alpacamundo info">info&#64;alpacamundo.eu</a><br>
Telefoon: +31 (0) 643887958<br>
<p>
Wij kunnen niet altijd direct de telefoon beantwoorden. 
Spreek de voicemail in, of laat een berichtje achter via SMS of WhatsApp. 
Wij nemen zo snel mogelijk contact me tu op.
<p>
Alpacamundo biedt <b>geen</b> rondleidingen, wandelingen of knuffelsessies aan met onze dieren. 
Graag verwijzen we daarvoor door naar andere alpaca boederijen die dit specifiek aanbieden.